export enum CookieKeys {
  HEADER_PAYLOAD = 'SgnPt1',
  SIGNATURE = 'SgnPt2',
  USER_ID = 'user_id',
  SOCIETY_INVITE_VIEWED = 'pre_approved_{% id %}_viewed',
  ONBOARDING_VIEWED = 'onboarding_viewed_{% id %}',
}
